qtee.customDesign = window.qtee.customDesign || {};

/** Product details view */
qtee.customDesign.DetailsView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/product-details',
	ui: {
		detailsWrapper: '.moreDetails',
		detailsToggle: '.detailsToggle',
		sizeChart: '.sizeChartLink',
		colors: '.color div:not(.active)[data-sku]',
		sizes: '.size div:not(.active)[data-sku]'
	},
	events: {
		'click @ui.detailsToggle': 'toggleDetails',
		'click @ui.colors': 'changeProduct',
		'click @ui.sizes': 'changeProduct'
	},
	modelEvents: {
		change: 'render'
	},
	templateHelpers: function templateHelpers () {

		const that = this;
		const price = this.model.get('Price') ? this.model.get('Price').substring(1) : '';
		const shippingInfo = this.model.get('ArrivesInMessage')
			? this.renderShippingInfo(this.model.get('ArrivesInMessage'), this.model.get('Shipping'))
			: '';

		return {
			price,
			shippingInfo,
			showTop: function showTop () {

				return that.options.showTop;

			},
			isEmpty: function isEmpty () {

				return that.options.isEmpty;

			}
		};

	},

	renderShippingInfo: function renderShippingInfo (message, shipping) {

		// estimated arrival message
		const inStockElement = $('#pdInStock');
		inStockElement.text(`In Stock - ${message}`);
		inStockElement.attr('aria-label', `In Stock - ${message}`);

		// isFreeShipping
		if (shipping.IsFreeShipping) {

			$('#freeShipping').html('FREE SHIPPING* <span> | </span>');

		} else {

			$('#freeShipping').hide();

		}

		// price
		if ($('.pdPriceWrapper .pdPrice').html()) {

			$('.pdPriceBottom .pdPrice').append($('.pdPriceWrapper .pdPrice').html());

		}

	}
});
